import { getCookieSettings } from '@lib/cookies'
import Cookies from 'js-cookie'
import { useEffect, useState } from 'react'

export function useSyncRolexCmpTracking() {
  const [rolexConsent, setRolexConsent] = useState(false)

  useEffect(() => {
    // Because changes in the cookie settings always trigger a refresh
    // We don't have to rerun the effect on changed settings
    const settings = getCookieSettings()

    const value = String(settings.includes('personal:rolex'))
    Cookies.set('rlx-consent', value, { expires: 365 })
    setRolexConsent(value === 'true')

    if (window?.['_satellite']?.setVar) {
      // Mandatory to disable default Adobe Analytics tracking
      // See Rolex implementation guidelines for more information
      // https://rocc.myrolexnetwork.com/en/rolex-on-your-website/bespoke-solution/bespoke-solution-guidelines/web-analytics-and-tracking-bespoke.html
      window?.['_satellite']?.setVar('Analyticsconsent', 'false')
    }
  }, [])

  return rolexConsent
}
